import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "ms-2 text-muted"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "单位：元", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "抽满此次数后触发保底", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "每次抽卡获得的卡牌数量", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mt-1" }, "选择触发保底时可以抽到的等级（如 SSR, SSSR）", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mt-1" }, "抽到这些等级的卡牌时，能量值归零（可选）", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "数字越小越靠前", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "开启后仅内部用户可见", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "开启后抽卡按消费金额/10获得积分", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "开启后卡牌进入背包显示\"预售\"，到货前不可发货", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("保存基本信息")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("卡池卡牌配置")
const _hoisted_16 = {
  key: 1,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ImageCropUploader = _resolveComponent("ImageCropUploader")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ItemsManager = _resolveComponent("ItemsManager")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.cardPool,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "所属系列",
          prop: "card_series_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.cardPool.card_series_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardPool.card_series_id) = $event)),
              placeholder: "请选择系列",
              filterable: "",
              disabled: !_ctx.isNew
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardSeriesOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            (!_ctx.isNew)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "（系列不可修改）"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "卡池名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.cardPool.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardPool.name) = $event)),
              placeholder: "请输入卡池名称",
              maxlength: "100",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "卡池图片",
          prop: "image"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ImageCropUploader, {
              modelValue: _ctx.cardPool.image,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardPool.image) = $event)),
              "aspect-ratio": 4/5,
              "preview-width": 140,
              "preview-height": 175,
              hint: "建议尺寸: 800 × 1000 px (4:5 竖图)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "列表横图" }, {
          default: _withCtx(() => [
            _createVNode(_component_ImageCropUploader, {
              modelValue: _ctx.cardPool.list_image,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cardPool.list_image) = $event)),
              "aspect-ratio": 679/263,
              "preview-width": 340,
              "preview-height": 132,
              hint: "建议尺寸: 679 × 263 px (横图，用于小程序列表页)。不上传则列表页使用卡池图片"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "描述",
          prop: "description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.cardPool.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardPool.description) = $event)),
              type: "textarea",
              rows: 3,
              placeholder: "请输入卡池描述",
              maxlength: "500",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "抽卡价格",
          prop: "price"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.cardPool.price,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cardPool.price) = $event)),
              min: 0,
              precision: 2,
              step: 1
            }, null, 8, ["modelValue"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "保底次数",
          prop: "energy_limit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.cardPool.energy_limit,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cardPool.energy_limit) = $event)),
              min: 1,
              max: 9999
            }, null, 8, ["modelValue"]),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "一包张数",
          prop: "cards_per_pack"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.cardPool.cards_per_pack,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cardPool.cards_per_pack) = $event)),
              min: 1,
              max: 99
            }, null, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "保底等级",
          prop: "guaranteed_rarities"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.cardPool.guaranteed_rarities,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cardPool.guaranteed_rarities) = $event)),
              multiple: "",
              "allow-create": "",
              filterable: "",
              placeholder: "请选择或输入触发保底时可出的等级",
              style: {"width":"100%","max-width":"400px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardRarityOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.name
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "重置能量等级",
          prop: "energy_trigger_rarities"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.cardPool.energy_trigger_rarities,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cardPool.energy_trigger_rarities) = $event)),
              multiple: "",
              "allow-create": "",
              filterable: "",
              placeholder: "请选择或输入抽到后重置能量的等级",
              style: {"width":"100%","max-width":"400px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardRarityOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.name
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sort"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.cardPool.sort,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cardPool.sort) = $event)),
              min: 0,
              max: 9999
            }, null, 8, ["modelValue"]),
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "enabled"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.cardPool.enabled,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cardPool.enabled) = $event)),
              "active-text": "启用",
              "inactive-text": "停用"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "仅内部测试" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.cardPool.is_test,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cardPool.is_test) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "抽卡加积分" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.cardPool.is_increase_membership_point,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cardPool.is_increase_membership_point) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "预售卡池" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.cardPool.is_presale,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cardPool.is_presale) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    (!_ctx.isNew && _ctx.savedPoolId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_el_divider, { "content-position": "left" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_ItemsManager, {
            "card-pool-id": _ctx.savedPoolId,
            "card-series-id": _ctx.cardPool.card_series_id,
            "guaranteed-rarities": _ctx.cardPool.guaranteed_rarities,
            onUpdate: _ctx.onItemsUpdate
          }, null, 8, ["card-pool-id", "card-series-id", "guaranteed-rarities", "onUpdate"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isNew)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_el_alert, {
            title: "提示",
            type: "info",
            description: "请先保存基本信息，保存后可以配置卡池中的卡牌",
            closable: false
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}